import classNames from 'classnames';
import { GetServerSideProps } from 'next';
import { Page } from '@customTypes/page';
import { Basket, Label } from '@graphql/generated';
import { addApolloState, initializeApollo } from '@lib/apolloClient';
import { Header, Footer } from '@components/index';
import { GET_MY_BASKET } from '@graphql/queries/basket';
import { GET_CATEGORY_LABELS, GET_MAIN_LABELS } from '@graphql/queries/labels';
import { parseCookies } from '@lib/parseCookies';
import Layout from '@layouts/CommonLayout';
import SearchContent from '@modules/search/components/SearchContent/SearchContent';
import styles from '@styles/pages/Search.module.scss';

const containerClass = 'container-wide';

const SearchPage: Page = () => (
  <div className={classNames(styles.root, containerClass)}>
    <SearchContent />
  </div>
);

SearchPage.getLayout = function getLayout(page) {
  return (
    <Layout headerComponent={Header} footerComponent={Footer}>
      {page}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const cookies = parseCookies(req);

  const apolloClient = initializeApollo({ token: cookies.token });

  try {
    await apolloClient.query<Label>({ query: GET_CATEGORY_LABELS });
    await apolloClient.query<Label>({ query: GET_MAIN_LABELS });
  } catch (error) {}

  try {
    await apolloClient.query<Basket>({ query: GET_MY_BASKET });
  } catch (error) {}

  return addApolloState(apolloClient, {
    props: {
      referer: req.headers.referer || '',
    },
  });
};

export default SearchPage;
